import UtmTracker from 'utils/utm_tracker'

class SaveUtmParamsToSessionStorage {
  static async init () {
    return UtmTracker.saveUtmParams()
  }
}

export default SaveUtmParamsToSessionStorage
